/**
 * Created by chenqifeng on 2017/2/7.
 */

import {request} from '../http';
import domain from '../domain';
import {getCookie} from '../util/cookie';
var ItemService = function(){
    if(domain.env === 'online'){
        this.domain = '//item.51tiangou.com';
    }else{
        this.domain = "//item." + domain.env + ".66buy.com.cn";
    }
};

ItemService.prototype.sugProduct = function (params) {
    var that = this;
    params.type = 'POST';

    params.data = params.data || {};

    params.data.uuid=getCookie('tgs_uuid');
    // if(params.data.id){
        that._serviceAjaxCom("/mallProduct/recommend/byMember", params);
    // }
};


ItemService.prototype.recommendDailySignByMember = function (params) {
    var that = this;
    params.type = 'POST';

    params.data = params.data || {};

    params.data.uuid=getCookie('tgs_uuid');
    // if(params.data.id){
        that._serviceAjaxCom("/recommend/dailySign/byMember", params);
    // }
};

ItemService.prototype.recommendCartByMember = function (params) {
    var that = this;
    params.type = 'POST';

    params.data = params.data || {};

    params.data.uuid=getCookie('tgs_uuid');
    // if(params.data.id){
        that._serviceAjaxCom("/recommend/cart/byMember", params);
    // }
};


ItemService.prototype.orderDetailRecItems = function(params){
    var that = this;
    params.type = "POST";
    that._serviceAjaxCom('/recommend/order/detail/recItems', params);
};





// 购物完成页面调用猜你喜欢接口
ItemService.prototype.sugProductInOrderFin = function (params) {
    var that = this;
    params.type = 'POST';
    params.data.uuid=getCookie('tgs_uuid');
    params.data.cellPhone=getCookie('cellPhone');
    params.data.memberId=getCookie('memberId');
    if(params.data.id){
        that._serviceAjaxCom("/front/listing/search/order/sug", params);
    }
};
// 通过商品ID将超市商品加入购物车
ItemService.prototype.addShoppingCart = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/front/market/addShoppingCart", params);
};
// 查询商品分类情况
ItemService.prototype.category = function (params) {
    var that = this;
    params.type = 'GET';
    that._serviceAjaxCom("/search/aggregation/market/category", params);
};


ItemService.prototype.notEvaluatedRecItems = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/recommend/order/notEvaluated/recItems", params);
};

ItemService.prototype.orderAllRecItems = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/recommend/order/all/recItems", params);
};
ItemService.prototype.pendingPaymentRecItems = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/recommend/order/pendingPayment/recItems", params);
};

ItemService.prototype.pendingDeliveryRecItems = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/recommend/order/pendingDelivery/recItems", params);
};

ItemService.prototype.orderArrivingRecItems = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/recommend/order/arriving/recItems", params);
};



ItemService.prototype.marketCategory = function (params) {
    var that = this;
    params.type = 'GET';
    that._serviceAjaxCom("/search/aggregation/category", params);
};

// 通过商品ID获取商品详情html
ItemService.prototype.queryDetail = function (params) {
    var that = this;
    params.type = 'GET';
    that._serviceAjaxCom("/front/listing/query/detail", params);
};
// 通过商品ID获取商品详情html
ItemService.prototype.search = function (params) {
    var that = this;
    params.type = 'GET';
    that._serviceAjaxCom("/front/listing/search", params);
};
// 通过商品ID获取天狗答疑
ItemService.prototype.productFaq = function (params) {
    var that = this;
    params.type = 'GET';
    that._serviceAjaxCom("/front/listing/productFaq", params);
};
ItemService.prototype._serviceAjaxCom = function(url,params){
    params.url = this.domain + url;
    return request(params);
};
/**
 * 删除收藏记录
 * @param params
 */
ItemService.prototype.updDelItemCollection  = function (params) {
	var that = this;
	that._serviceAjaxCom("/mallActivityProductToFitting/updDelItemCollection", params);
};


/**
 * 过滤商品的参数，非购物页搜索。。。
 * */
ItemService.prototype.aggregationFilter = function(params){
	params.type = 'POST';

	this._serviceAjaxCom('/search/aggregation/filter', params);
};

/**
 * 过滤商品的参数，购物页搜索。。。
 * */
ItemService.prototype.aggregationPlatformFilter = function(params){
	params.type = 'POST';

	this._serviceAjaxCom('/search/aggregation/platform/filter', params);
};

/**
 * 周期购猜你喜欢商品
 * */
ItemService.prototype.suggestProduct = function(params){
    params.type = 'POST';

    this._serviceAjaxCom('/search/suggest/oversea/items', params);
};
/**
 * 新版首页找相似
 * */
ItemService.prototype.similar = function(params){
    params.type = 'POST';

    this._serviceAjaxCom('/recommend/shopping/similar', params);
};
/**
 * 海外购分类全部品牌
 * */
ItemService.prototype.queryBrandByTopBizId = function(params){
    params.type = 'POST';

    this._serviceAjaxCom('/frontBizCategory/queryBrandByTopBizId', params);
};

/**
 * 获取商品信息
 * */
ItemService.prototype.itemDetailInfo = function(params){
    params.type = 'POST';

    return this._serviceAjaxCom('/front/listing/itemDetailInfo', params);
};

/**
 * 获取搜索联想词 跨境
 * */
ItemService.prototype.queryOverseasCompleteWords = function(params){
    params.type = 'POST';

    return this._serviceAjaxCom('/search/oversea/queryCompleteWords', params);
};

/**
 * 获取搜索联想词 购物
 * */
ItemService.prototype.queryPlatformCompleteWords = function(params){
    params.type = 'POST';

    return this._serviceAjaxCom('/search/platform/queryCompleteWords', params);
};

/**
 * 获取搜索联想词 百货
 * */
ItemService.prototype.queryMallCompleteWords = function(params){
    params.type = 'POST';

    return this._serviceAjaxCom('/search/mall/queryCompleteWords', params);
};

/**
 * 获取搜索联想词 超市
 * */
ItemService.prototype.queryMarketCompleteWords = function(params){
    params.type = 'POST';

    return this._serviceAjaxCom('/search/market/queryCompleteWords', params);
};

/**
 * 推荐品
 * */
ItemService.prototype.getPlatformSug = function(params){
    params.type = 'POST';

    return this._serviceAjaxCom('/search/suggest/platform/items', params);
};

/**
 * #49161 线下用触点进行用户线上订单转化
 * 获取商品接口
 * */
ItemService.prototype.getOrderFinSug = function(params){
    return this._serviceAjaxCom('/front/listing/orderComplete/sug', params);
};

/**
 * 三级分类落地页查询三级分类标签
 * */
ItemService.prototype.leafLabels = function(params){
    return this._serviceAjaxCom('/front/supplierCategory/leafLabels', params);
};

// 获取sku预估到手价
ItemService.prototype.getProbablyPrice = function(params){
    return this._serviceAjaxCom('/front/listing/getProbablyPrice', params);
};

export default new ItemService();